import { render } from "./SessionParticipationReport.vue?vue&type=template&id=0e1884f5&scoped=true"
import script from "./SessionParticipationReport.vue?vue&type=script&lang=js"
export * from "./SessionParticipationReport.vue?vue&type=script&lang=js"

import "./SessionParticipationReport.vue?vue&type=style&index=0&id=0e1884f5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1884f5"]])

export default __exports__